




























import { ObjectFactory } from '@/config/objectFactory';
import { EventBus } from '@/main';
import { ToastEvent } from '@/types/event';
import { ApiRequest, CreateAccessKeyRequest } from '@/types/request';
import { AccessKey } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
import AccessKeyModal from '../modal/AccessKeyModal.vue';
@Component({
    mixins: [validationMixin],
    components: {
        AccessKeyModal,
    },
    data() {
        return {
            keyName: '',
            accessKey: {},
        };
    },
    validations: {
        keyName: {
            required,
        },
    },
})
export default class AddAPIKeyModal extends Vue {
    private show = true;
    private showAccessKeyModal = false;

    private close() {
        this.$router.back();
    }

    private async addAPIKey() {
        const iHttpService = ObjectFactory.getHttpService();
        const createAccessKeyRequest: CreateAccessKeyRequest = {
            keyName : this.$data.keyName,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ACCESS_KEYS}`,
            data: createAccessKeyRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post <AccessKey>(apiRequest);
        if (response.success && response.data) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_ACCESS_KEY'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$data.accessKey = response.data;
            this.showAccessKeyModal = true;
        } else {
            CommonUtils.showError(response);
        }
    }
}
